var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PgForm,{ref:"formRef",attrs:{"formItems":_vm.formItems,"model":_vm.model,"extendCompileData":_vm.extendCompileData},nativeOn:{"scroll":function($event){return _setup.scroll.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }